interface UseDescriptionProps {
  package_name?: string
  categoryOptions?: CategoryOption[]
}

export const useDescription = ({
  package_name,
  categoryOptions
}: UseDescriptionProps) => {
  const isFlatRate = !!package_name

  const showAttributes = !!categoryOptions && categoryOptions?.length !== 0

  const categoryOptionsNames = categoryOptions
    ?.map((option) => option.attribution.name + ' ' + option.name)
    .join(' \u2022 ')

  return {
    isFlatRate,
    showAttributes,
    categoryOptionsNames
  }
}
